import React from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';

const PageDescription = brandedData => {
  const { body, headline: title } = brandedData;
  return (
    <div className='container brand-page'>
      <div className='col-12'>
        <div className='row pt-3 pb-3'>
          <div className='col-12'>
            <h1 className='title text-uppercase font-weight-bold position-relative ng-binding'>{title}</h1>
          </div>
        </div>
      </div>

      <div className='col-12'>
        <div className='description' dangerouslySetInnerHTML={{ __html: documentToHtmlString(body) }} />
      </div>
    </div>
  );
};

export default PageDescription;
